export const PAYMENT_STATUS = {
  PENDING: 0,
  PAID: 1,
  FAILED: 2,
  ABANDONED: 3,
};

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS.PENDING]: { en: 'Pending', ar: 'قيد الانتظار' },
  [PAYMENT_STATUS.PAID]: { en: 'Paid', ar: 'مدفوع' },
  [PAYMENT_STATUS.FAILED]: { en: 'Failed', ar: 'فشل' },
  [PAYMENT_STATUS.ABANDONED]: { en: 'Abandoned', ar: 'مهجور' },
};

export const PAYMENT_STATUS_COLORS = {
  [PAYMENT_STATUS.PENDING]: { bg: '#E5E7EB', fg: '#374151' },
  [PAYMENT_STATUS.PAID]: { bg: '#DCFCE7', fg: '#15803D' },
  [PAYMENT_STATUS.FAILED]: { bg: '#FEE2E2', fg: '#B91C1C' },
  [PAYMENT_STATUS.ABANDONED]: { bg: '#FEF3C7', fg: '#B45309' },
};

export const getPaymentStatusLabel = (value, locale = 'en') => {
  const entry = PAYMENT_STATUS_LABELS[value];
  return entry ? entry[locale] || entry.en : '';
};
